/**
 * 扣款登记
 * */

import React from 'react'
import Lang from "@components/Lang/Lang";
import {Form,DatePicker, Input,Button,Row,Col,Select,message,} from "antd";
import EssaModal from "@/components/EssaModal/EssaModal";
import {splitNumber,isEmpty} from '@utils/utils';
import "./index.less";
import SearchSelector from '@components/SearchSelector/SearchSelector';
import dayjs from "dayjs";
// import customParseFormat from 'dayjs/plugin/customParseFormat';
import Cookie from "../../../../utils/cookie";
import Locale from "../../../../utils/locale";
import PaymentCheckOutAction from "../PaymentCheckOut.action";
import 'dayjs/plugin/updateLocale';
let locale = Locale.current();
const { TextArea } = Input;
const { Option } = Select;
const FormItem  = Form.Item;

//
// dayjs.updateLocale('zh-cn', {
//     weekStart: 0,
// });

class Add extends React.Component{
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            submitLoading:false,
            valueMoneyOut: '',
            strMoneyOut: '',
            size:'large',
            visible:false,
            valuesForm:{},
            checkSureInfo:{},
            focusNumber:false,
            isCheck: 1,
            hasPermission:2,//未设置
        }
        let extra = Cookie.getJSON("fmg.extra") || {};
        this.params = {
            payTypeList:[],
            //是否触发验证
            isTriggerVerify:false,
            currencySymbol:extra.currencySymbol||"'"
        }

        let payTypeList = __getDictList('fin_remittance_item_pay_type');
        payTypeList.map( (item)=> {
            if(item.code=='BANK_TRANSFER'||item.code=='CASH'){
                this.params.payTypeList.push(item)
            }
        });
    }

    /**
     * 二次确认
     */
    onCheck=()=> {
        this.params.isTriggerVerify = true;
        const { validateFields } = this.formRef.current;
        validateFields().then((values) => {
                const checkedItem = this.onRefFormSearchRef.getSelectedItem();
                values.buyerCode = checkedItem.buyerCode;
                this.flagShowModal(true,values)
            }).catch((errorInfo) => { 
        });
    };
    flagShowModal(flag=false,values={}){
        this.setState({
            visible: flag,
            submitLoading:flag,
            valuesForm:values,
            isCheck:1,
            checkSureInfo:{},
        })
    }
    handleOk(values){
        const {isCheck, currencySymbol,countryCode} = this.state;
        let moneyOutTime = (values.moneyOutTime).format('YYYY/MM/DD');
        moneyOutTime = dayjs(moneyOutTime + ' 23:59:59').valueOf();
        const data = {
            bankSeq:values.bankSeq,
            buyerId:values.buyerId,
            moneyOut:Number(values.moneyOut),
            moneyOutTime:dayjs(moneyOutTime).valueOf(),
            payType:values.payType,
            remark:values.remark,
            isCheck:isCheck,
            currencySymbol: currencySymbol,
            countryCode:countryCode
        }
        PaymentCheckOutAction.saveAddEduction(data).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err))
    }
    handleRes(res){
        const {success,valid,model} = res;
        if(success&&valid){
            message.success(__getServerLanguage('TiJiaoChengGong'))
            this.flagShowModal();//关闭
            //清空表单
            this.params.isTriggerVerify = false;
            this.formRef.current.resetFields();
            this.setState({
                valueMoneyOut: '',
                strMoneyOut: '',
            })
            this.onChangeRow({});//清空选择
            //回调
            if(typeof this.props.callBack == 'function'){
                this.props.callBack();
            }
        }else if(!res.valid && res.model){
            const checkSureInfo = res.model;
            if(checkSureInfo.type=='1'){
                this.setState({
                    checkSureInfo:checkSureInfo,
                    isCheck:0,
                })
            }else {
                const {valuesForm } = this.state;
                // const num = Number(valuesForm.moneyOut) - checkSureInfo.money;
                message.warning(Lang({id:'DangQianKeHuYuE',default:'当前客户余额{0}',params:[checkSureInfo.money]}))
            }
        }else if(res.message) message.warning(res.message)

    }
    /**
     * 修改数字
     */
    changeNumber(e){
        let { value } = e.target;
        const { setFieldsValue } = this.formRef.current;
        if(!isEmpty(value)){
            value = value.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
            value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
            value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
        }
        setFieldsValue({
            moneyOut: value
        });
        this.setState({
            valueMoneyOut: value,
            strMoneyOut: value.replace(/\d{1,3}(?=(\d{3})+(\.|$))/g,'$& ').replace('.',',')
        })
    }
    changeNumberFocus(flag=true){
        this.setState({
            focusNumber :flag
        })
    }
    // 选择客户后回调行数据
    onChangeRow(dat={}){
        this.setState({
            countryName: dat.countryName,
            currencySymbol:dat.currencySymbol,
            hasPermission:isEmpty(dat.hasPermission)?2:dat.hasPermission,// 为2 时 无操作或清空选择
            countryCode:dat.countryCode
        })
    }
    onRefFormSearch = (ref) =>  this.onRefFormSearchRef = ref;
    render(){
        const {submitLoading,valueMoneyOut, strMoneyOut,size,visible,valuesForm,checkSureInfo,focusNumber,countryName,hasPermission,currencySymbol} = this.state;
        let layout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            labelAlign:"left"
        };
        if(locale!='zh'){
            layout = {
                labelCol: { span: 7 },
                wrapperCol: { span: 17 },
                labelAlign:"left"
            };
        }
        return (
            <div className="payment-check-in-add-wrap">
                <Form
                    ref={this.formRef}
                    {...layout}
                    name="basic"
                >
                    <FormItem
                        label={__getServerLanguage('KeHu')}
                        name="buyerId"
                        rules={[{ required: true, message: Lang({id: "QingShuRuKeHuBianMa",default: "请输入客户编码",})}]}
                    >
                        {/*<BuyerSelector size={size} callBack={this.BuyerSelectorCallBack}></BuyerSelector> 复制客户名赋值时有BUG不建议使用*/}
                        <SearchSelector size={size}
                                        onRef={this.onRefFormSearch}
                                        title= {Lang({id: "KeHu",default: "客户",})}
                                        onChangeRow={(dat)=>this.onChangeRow(dat)}
                                        searchField={'keyWord'}
                                        api={'/service/mg/fin/ddp/remittance-item/buyerList'}
                                        field = {[
                                                { cnTitle: '客户编号',cnTitleId:'KeHuBianHao', dataIndex:'buyerCode'},
                                                { cnTitle: '客户名称',cnTitleId:'KeHuMingCheng', dataIndex:'buyerName'},
                                                { title: 'ID',dataIndex:'buyerId'},
                                                { cnTitle: '所属国家',cnTitleId:'SuoShuGuoJia',dataIndex:'countryName'},
                                                { cnTitle: '交易货币',cnTitleId:'JiaoYiHuoBi',dataIndex:'currencySymbol'},
                                            ]}
                                        idField={'buyerId'} />
                    </FormItem>
                    <FormItem
                        label={Lang({id: 'HuiKuanRiQi', default: '汇款日期'})}
                        name="moneyOutTime"
                        initialValue={dayjs()}
                        rules={[{ required: true, message:Lang({id: 'QingXuanZeHuiKuanRiQi', default: '请选择汇款日期'})}]}
                    >
                        <DatePicker size={size}
                                    placeholder={Lang({id: 'QingXuanZeHuiKuanRiQi', default: '请选择汇款日期'})} format="YYYY-MM-DD" />
                    </FormItem>
                    <FormItem
                        label={Lang({id: 'YinHangLiuShuiHao', default: '银行流水号'})}
                        name="bankSeq">
                        <Input maxLength={100} size={size} placeholder={Lang({id: 'QingShuRuYinHangLiuShuiHao', default: '请输入银行流水号'})}/>
                    </FormItem>
                    <FormItem
                        label={Lang({id: 'TuiKuanFangShi', default: '退款方式'})}
                        name="payType"
                        rules={[{ required: true, message:Lang({id: 'QingXuanZeTuiKuanFangShi', default: '请选择退款方式'})}]}
                    >
                        <Select size={size} placeholder={Lang({id: 'QingXuanZeTuiKuanFangShi', default: '请选择退款方式'})}>
                            {this.params.payTypeList.map(function (item,index) {
                                return <Option key={index} value={item.code}>{item.name}</Option>
                            })}
                        </Select>
                    </FormItem>
                    <FormItem
                        label={Lang({id:"KeHuQianBao",default:"客户钱包"})}
                        name="countryName"
                    >
                        <p className={`black66${!countryName&&hasPermission!=2?" color-err":""}`}>
                            {Lang({id:"KeHuDangQianQianBaoSuoShuGuoJia",default:"客户当前钱包所属国家"})}
                            <span className={"ml_6"}>{!countryName&&hasPermission!=2?Lang({id:"ZanMeiQueRen",default:"暂没确认"}):countryName}</span>
                        </p>
                    </FormItem>
                        <FormItem
                            label={Lang({id: 'KouJianJinE', default: '扣减金额'})}
                            name="moneyOut"
                            rules={[
                                {required: true, message: Lang({id: 'QingShuRuKouJianJinE', default: '请输入扣减金额'})}
                            ]}
                            className={"bold_input"}
                        >
                                <Input ize={size} maxLength={10}
                                       onChange={this.changeNumber.bind(this)}
                                       onFocus = {()=>this.changeNumberFocus(true)}
                                       onBlur  = {()=>this.changeNumberFocus(false)}
                                       value={valueMoneyOut}
                                       addonBefore={<span>{currencySymbol}</span>}
                                       placeholder={ Lang({id: 'QingShuRuKouJianJinE', default: '请输入扣减金额'})}/>
                            {strMoneyOut&&<div className={"popup-moq-tips"} style={focusNumber?{display:'block'}:{}}>{strMoneyOut}</div>}
                        </FormItem>
                    <FormItem
                        label={Lang({id: 'BeiZhu', default: '备注'})}
                        name="remark">
                        <TextArea size={size} autoSize={{ minRows: 4, maxRows: 4 }} maxLength={600} placeholder={__getServerLanguage('QingShuRuBeiZhuXinXi')}/>
                    </FormItem>
                    <Row>
                        <Col offset={layout.labelCol.span} span={layout.wrapperCol.span}>
                            <Button size={size} loading={submitLoading} onClick={this.onCheck}
                                    disabled={hasPermission==0}
                                    type="primary" shape="round">
                                {hasPermission==0?Lang({id:"WuQuanXian",default:"无权限"}):__getServerLanguage('XinZeng')}
                            </Button>
                        </Col>
                    </Row>
                </Form>
                {visible&&<EssaModal title={Lang({id: "TiShi",default: "提示"})}
                                     open={visible}
                                     width={600}
                                     onOk={()=>this.handleOk(valuesForm)}
                                     onCancel={()=>this.flagShowModal(false)}>
                    {checkSureInfo&&checkSureInfo.buyerCode?<div>
                        <p className={"font_18 font-main"} dangerouslySetInnerHTML={{ __html: __getServerLanguage('KeHuZaiDengJiLeiTongYangDeJinE',`<span class="ml_4 mr_4">${checkSureInfo.buyerCode}</span>`,
                                `<span class="ml_4 mr_4">${checkSureInfo.time?dayjs(checkSureInfo.time).format("YYYY-MM-DD HH:mm:ss"):''}</span>`,
                                `<span class="ml_4 mr_4">${strMoneyOut}</span><span>${currencySymbol}</span>`) }}>
                        </p>
                        <p className={"font_14 font-title"}>{Lang({id: "ShiFouJiXuDengJi",default: "是否继续登记"})}?</p>
                    </div>:<div>
                        <p className={"font_14"}>{Lang({id:'QingQueRenLuRuDeKouJianJinEShiFouZhengQue',default:"请确认录入的扣减金额是否正确？"})}</p>
                        <div className={"pop_tips_deduction_grey mt_8"}>
                            <div className={"font_24"}>{valuesForm.buyerCode||'-'}</div>
                            <div className={"font_36 font-main p-title"}><span className={"plus_icon mr_12"}>-</span>{strMoneyOut}<span className={"ml_12"}>{currencySymbol}</span></div>
                        </div>
                        </div>}
                </EssaModal>}
            </div>
        )
    }
}

Add.defaultProps = {
    callBack:function () {

    }
}

Add.propTypes = {

}
export default Add;
